import styled from 'styled-components';

import { SemanticColorKey, getSemanticColor } from '@notino/react-styleguide-v20';

interface IStyledProgressBarProps {
  undoneColor: SemanticColorKey;
  maxWidth?: number;
}

interface IStyledThumbProps {
  percentage: number;
  successColor: SemanticColorKey;
}

export const StyledProgressBar = styled.div<IStyledProgressBarProps>`
  margin: 0.5rem auto;
  min-height: 0.4rem;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}rem` : '21rem')};
  width: 100%;
  background-color: ${({ undoneColor }) => (undoneColor ? getSemanticColor(undoneColor) : 'transparent')};
  border-radius: 2px;
`;

export const Thumb = styled.div<IStyledThumbProps>`
  width: ${({ percentage }) => percentage}%;
  min-height: inherit;
  background-color: ${({ successColor }) => (successColor ? getSemanticColor(successColor) : 'transparent')};
  transition: width 0.3s ease-in-out;
  border-radius: 2px;
`;
